// src/components/ProtectedRoute.jsx
import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from './firebase';
import { Typography } from '@mui/material';

const ProtectedRoute = ({ children, allowedRole }) => {
  const [user, loading] = useAuthState(auth);
  const [role, setRole] = useState(null);
  const [roleLoading, setRoleLoading] = useState(true);

  useEffect(() => {
    if (user) {
      const fetchRole = async () => {
        try {
          const tokenResult = await user.getIdTokenResult(true);
          const userRole = tokenResult.claims.role || null;
          setRole(userRole);
          console.log(`Role ${userRole} loaded for UID: ${user.uid}`);
        } catch (err) {
          console.error('Error loading role:', err);
          setRole(null);
        } finally {
          setRoleLoading(false);
        }
      };
      fetchRole();
    } else {
      setRoleLoading(false);
    }
  }, [user]);

    if (loading || roleLoading) return <Typography>Loading...</Typography>;
  if (!user) return <Navigate to="/market" replace />;


  
  const isEmailAuth = user?.providerData?.some(
    p => p?.providerId === "password" || p?.providerId === "emailLink"
  );

  if (isEmailAuth && !user.emailVerified) {
    return <Navigate to="/verify-email" replace state={{ email: user.email }} />;
  }

  if (allowedRole && role !== allowedRole) {
    return <Navigate to="/login" replace />;
  }

  return children;

};

export default ProtectedRoute;
